import React from 'react';
// import Video2 from '../../images/v-shape.jpg'

const VideoSectionS2 = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="wpo-video-item">
                    <div className="row">
                        <div className={`col-lg-12 col-md-12 col-12 ${props.Vbuttom}`}>
                            <div className="why-choose-wrap">
                                <div className="why-choose-left">
                                    <h2>Why us?   </h2>
                                    <p>We provide fast, safe and efficient logistics. Our experience, modern technologies and individual approach guarantee reliable delivery. We offer optimal routes, control at all stages of transportation and high quality service. Trust us with your cargo – we will deliver it right on time!</p>
                                </div>
                                <div className="why-choose-right">
                                    <div className="wpo-choose-check-wrap">
                                        <div className="wpo-choose-check-item">
                                            <h2>Safety</h2>
                                            <p>Full control and safety of cargo at all stages of transportation.</p>
                                        </div>
                                        <div className="wpo-choose-check-item">
                                            <h2>Fast delivery</h2>
                                            <p>
                                                Our company offers fast delivery services for those who value time and need prompt solutions to transportation problems.
                                            </p>
                                        </div>
                                        <div className="wpo-choose-check-item">
                                            <h2>Pricing</h2>
                                            <p>The cost of our services is calculated individually, taking into account the specifics of your cargo, route and additional requirements.</p>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="v-shape">
                                    <img src={Video2} alt="" />
                                </div> */}
                            </div>
                        </div>
                        {/* <div className={`col-lg-12 col-md-12 col-12 ${props.Vtop}`} >
                            <div className="wpo-video-icon ">
                                <VideoModal />
                            </div>
                            <div className="wpo-viedo-title">
                                <h2>Посмотрите наше вступительное видео и узнайте, как легко получить наши услуги.</h2>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VideoSectionS2;